import { buildUrlWithQueryParameters, extractPathFromHash, getQueryParamsFromHref, getQueryParams, isValidURL, objectToQueryString, removeLeadingHashtagFromNavigationHashIfNeeded, updateQueryParams, } from '@famly/vet_ts-utils_url';
export { 
/**
 * @deprecated import from '@famly/vet_ts-utils_url' instead
 */
buildUrlWithQueryParameters, 
/**
 * @deprecated import from '@famly/vet_ts-utils_url' instead
 */
extractPathFromHash, 
/**
 * @deprecated import from '@famly/vet_ts-utils_url' instead
 */
getQueryParamsFromHref, 
/**
 * @deprecated import from '@famly/vet_ts-utils_url' instead
 */
getQueryParams, 
/**
 * @deprecated import from '@famly/vet_ts-utils_url' instead
 */
isValidURL, 
/**
 * @deprecated import from '@famly/vet_ts-utils_url' instead
 */
objectToQueryString, 
/**
 * @deprecated import from '@famly/vet_ts-utils_url' instead
 */
removeLeadingHashtagFromNavigationHashIfNeeded, 
/**
 * @deprecated import from '@famly/vet_ts-utils_url' instead
 */
updateQueryParams, };
export const isBadNetworkError = (error) => {
    // Chrome: "Failed to fetch", Safari: "Load failed". Both mean a connectivity issue.
    // Matched by prefix because `@sentry/browser` v10's fetch instrumentation enriches the
    // native TypeError with the request hostname, e.g. `Load failed (api.famly.de)`.
    if (!(error instanceof TypeError)) {
        return false;
    }
    return error.message.startsWith('Failed to fetch') || error.message.startsWith('Load failed');
};
